import type {TriggerIntegration} from '@cohort/merchants/apps';
import CohortFormTriggerIntegrationActionCtaComponentPreview from '@cohort/merchants/apps/cohort-form/triggerIntegrations/common/ActionCtaComponentPreview';
import StepCompletionContextComponent from '@cohort/merchants/apps/cohort-form/triggerIntegrations/common/StepCompletionContextComponent';
import StepCompletionsGridComponent from '@cohort/merchants/apps/cohort-form/triggerIntegrations/common/StepCompletionsGridComponent';
import StepCompletionTitleComponent from '@cohort/merchants/apps/cohort-form/triggerIntegrations/common/StepCompletionTitleComponent';
import useStepCompletionColumns from '@cohort/merchants/apps/cohort-form/triggerIntegrations/common/useStepCompletionColumns';
import CohortFormNumberTriggerConfigComponent from '@cohort/merchants/apps/cohort-form/triggerIntegrations/number/ConfigComponent';
import CohortFormNumberTriggerIntegrationComponentPreview from '@cohort/merchants/apps/cohort-form/triggerIntegrations/number/TriggerComponentPreview';
import type {CohortFormNumberTriggerStruct} from '@cohort/shared/apps/cohort-form/triggers/number';
import {CohortFormNumberTriggerIntegrationSpec} from '@cohort/shared/apps/cohort-form/triggers/number';

export const CohortFormNumberTriggerIntegration: TriggerIntegration<CohortFormNumberTriggerStruct> =
  {
    spec: CohortFormNumberTriggerIntegrationSpec,
    configComponent: CohortFormNumberTriggerConfigComponent,
    stepCompletionTitleComponent: StepCompletionTitleComponent,
    stepCompletionContextComponent: StepCompletionContextComponent,
    useStepCompletionColumns: useStepCompletionColumns,
    stepCompletionsGridComponent: StepCompletionsGridComponent,
    getTitle: t => t('triggerIntegrations.number.title', {ns: 'app-cohort-form'}),
    preview: {
      CtaComponent: CohortFormTriggerIntegrationActionCtaComponentPreview,
      TriggerComponent: CohortFormNumberTriggerIntegrationComponentPreview,
    },
  };
